module.exports = __webpack_public_path__ + "static/media/zeleny-semafor.aa3c8044.svg";